export default "/_next/static/chunks/fonts/Channel4Chadwick-Light-bb6385d306b02492ba864965317cdad8.woff";